import { useState, FormEvent } from "react";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const charLimit = 500;

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (message.length > charLimit) return;
    setSubmitting(true);
    const data = new URLSearchParams();
    new FormData(e.currentTarget).forEach((v, k) =>
      data.append(k, v as string),
    );
    try {
      await fetch("https://readdy.ai/api/form/d7a0eaqdqn9mib2trd1g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      /* silent */
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 px-6 bg-texas-cream">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="text-texas-red text-xs font-bold tracking-widest uppercase mb-3 block">
            Reach Out
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-texas-navy">
            Contact Us
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 items-start">
          {/* Contact Form */}
          <div className="w-full lg:w-1/2">
            {submitted ? (
              <div className="text-center py-12 bg-white rounded-lg border border-gray-100 h-full flex flex-col items-center justify-center">
                <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 bg-texas-red/10 rounded-full">
                  <i className="ri-check-line text-2xl text-texas-red" />
                </div>
                <p className="text-texas-navy text-lg font-medium">
                  Thank you! We'll be in touch soon.
                </p>
              </div>
            ) : (
              // <form
              //   id="contact-form"
              //   data-readdy-form
              //   onSubmit={handleSubmit}
              //   className="flex flex-col gap-5 bg-white rounded-lg p-8 border border-gray-100"
              // >
              //   <div>
              //     <label
              //       htmlFor="first_name"
              //       className="block text-sm font-medium text-texas-navy mb-1"
              //     >
              //       Name <span className="text-texas-red">*</span>
              //     </label>
              //     <input
              //       type="text"
              //       id="first_name"
              //       name="names[first_name]"
              //       required
              //       placeholder="Enter Your First Name"
              //       className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-texas-red/30"
              //     />
              //   </div>
              //   <div>
              //     <label
              //       htmlFor="email"
              //       className="block text-sm font-medium text-texas-navy mb-1"
              //     >
              //       Email <span className="text-texas-red">*</span>
              //     </label>
              //     <input
              //       type="email"
              //       id="email"
              //       name="email"
              //       required
              //       placeholder="Email Address"
              //       className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-texas-red/30"
              //     />
              //   </div>
              //   <div>
              //     <label
              //       htmlFor="description"
              //       className="block text-sm font-medium text-texas-navy mb-1"
              //     >
              //       Message <span className="text-texas-red">*</span>
              //     </label>
              //     <textarea
              //       id="description"
              //       name="description"
              //       required
              //       rows={4}
              //       maxLength={charLimit}
              //       value={message}
              //       onChange={(e) => setMessage(e.target.value)}
              //       className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-texas-red/30 resize-none"
              //     />
              //     <p
              //       className={`text-xs mt-1 text-right ${message.length >= charLimit ? "text-texas-red" : "text-gray-400"}`}
              //     >
              //       {message.length}/{charLimit}
              //     </p>
              //   </div>
              //   <button
              //     type="submit"
              //     disabled={submitting || message.length > charLimit}
              //     className="bg-texas-red hover:bg-texas-red-dark disabled:opacity-60 text-white text-sm font-semibold px-8 py-3 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap self-start"
              //   >
              //     {submitting ? "Submitting..." : "Submit"}
              //   </button>
              // </form>
              <form
                id="contact-form"
                data-readdy-form
                onSubmit={async (e) => {
                  e.preventDefault();
                  if (submitting || message.length > charLimit) return;

                  try {
                    setSubmitting(true);

                    const emailjs = (await import("@emailjs/browser")).default;

                    await emailjs.sendForm(
                      "service_n2rywap",
                      "template_raid7da",
                      e.target,
                      "FxKUKhiVggS6q3DYz",
                    );

                    setSubmitted(true);
                    e.target.reset();
                    setMessage("");
                  } catch (err) {
                    console.error(err);
                    alert("Failed to send message");
                  } finally {
                    setSubmitting(false);
                  }
                }}
                className="flex flex-col gap-5 bg-white rounded-lg p-8 border border-gray-100"
              >
                <div>
                  <label
                    htmlFor="first_name"
                    className="block text-sm font-medium text-texas-navy mb-1"
                  >
                    Name <span className="text-texas-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    placeholder="Enter Your First Name"
                    className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-texas-red/30"
                  />
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-texas-navy mb-1"
                  >
                    Email <span className="text-texas-red">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    placeholder="Email Address"
                    className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-texas-red/30"
                  />
                </div>

                <div>
                  <label
                    htmlFor="description"
                    className="block text-sm font-medium text-texas-navy mb-1"
                  >
                    Message <span className="text-texas-red">*</span>
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    required
                    rows={4}
                    maxLength={charLimit}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-texas-red/30 resize-none"
                  />
                  <p
                    className={`text-xs mt-1 text-right ${
                      message.length >= charLimit
                        ? "text-texas-red"
                        : "text-gray-400"
                    }`}
                  >
                    {message.length}/{charLimit}
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={submitting || message.length > charLimit}
                  className="bg-texas-red hover:bg-texas-red-dark disabled:opacity-60 text-white text-sm font-semibold px-8 py-3 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap self-start"
                >
                  {submitting ? "Submitting..." : "Submit"}
                </button>
              </form>
            )}
          </div>

          {/* Map + Info */}
          <div className="w-full lg:w-1/2 flex flex-col gap-4">
            {/* Google Map Embed */}
            <div className="w-full h-64 md:h-72 rounded-lg overflow-hidden border border-gray-200">
              <iframe
                title="Texas CSA Austin Office"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.0!2d-97.7588!3d30.3698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644b56145c1c1a1%3A0x0!2s5900+Balcones+Dr%2C+Austin%2C+TX+78731!5e0!3m2!1sen!2sus!4v1700000000000"
              />
            </div>

            {/* Office Details */}
            <div className="bg-white rounded-lg border border-gray-100 p-6 flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-texas-red/10 rounded-md mt-0.5">
                  <i className="ri-map-pin-line text-texas-red text-base" />
                </div>
                <div>
                  <p className="text-xs font-bold text-texas-navy uppercase tracking-wide mb-0.5">
                    Address
                  </p>
                  <p className="text-sm text-gray-600">
                    5900 Balcones Dr, Suite 30942
                    <br />
                    Austin, TX 78731
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-texas-red/10 rounded-md mt-0.5">
                  <i className="ri-phone-line text-texas-red text-base" />
                </div>
                <div>
                  <p className="text-xs font-bold text-texas-navy uppercase tracking-wide mb-0.5">
                    Phone
                  </p>
                  <a
                    href="tel:210-448-6057"
                    className="text-sm text-gray-600 hover:text-texas-red transition-colors cursor-pointer"
                  >
                    210-448-6057
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-texas-red/10 rounded-md mt-0.5">
                  <i className="ri-mail-line text-texas-red text-base" />
                </div>
                <div>
                  <p className="text-xs font-bold text-texas-navy uppercase tracking-wide mb-0.5">
                    Email
                  </p>
                  <a
                    href="mailto:contact@mytexascsa.com"
                    className="text-sm text-gray-600 hover:text-texas-red transition-colors cursor-pointer"
                  >
                    contact@mytexascsa.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
